module.exports = __webpack_public_path__ + "static/img/Eniksen_Logo_def.72a7889a.jpg";